import styles from "./styles.module.scss";

type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  wrapperHeight?: number;
  wrapperWidth?: number;
};

export const Checkbox = (props: CheckboxProps): JSX.Element => {
  const {
    onChange,
    checked,
    width = 16,
    height = 16,
    wrapperHeight = "auto",
    wrapperWidth = "auto",
    onClick,
    ...rest
  } = props;

  return (
    <div
      style={{
        height: wrapperHeight,
        width: wrapperWidth,
      }}
      className={styles.wrapper}
      onClick={onClick}
    >
      <label
        style={{
          width,
          height,
        }}
        className={styles.container}
      >
        <input
          type="checkbox"
          onChange={onChange}
          onClick={(ev) => ev.stopPropagation()}
          checked={checked}
          {...rest}
        />
        <span
          style={{
            width,
            height,
          }}
          className={styles.checkmark}
        />
      </label>
    </div>
  );
};
